import { Loader } from '@grafikr/components';

export default Loader(({ node }, load) => {
  const searchParams = new URLSearchParams(window.location.search);
  const urlParam = node.dataset.loadUrlParam.split(':');

  const [key, value] = urlParam;

  if (searchParams.has(key)) {
    if (value) {
      if (searchParams.get(key) === value) {
        load();
      }
    } else {
      load();
    }
  }
});
